import { type ReactNode } from 'react'

import { type RecType } from '@/defs/rec'
import { formatPercentage } from '@/utils/formatUtil'

import { StatCommonBox } from '../../StatCommon/StatCommonBox/StatCommonBox'
import { StatCommonFigure } from '../../StatCommon/StatCommonFigure/StatCommonFigure'

type Props = {
  isInView?: boolean
  rec: RecType
  variant?: 'added' | 'cut'
}

type ConfigType = Record<NonNullable<Props['variant']>, () => { inclusion?: string; label: string; tooltip: ReactNode }>

export const StatRecInclusionAddedCut = ({ isInView, rec, variant = 'cut' }: Props) => {
  const { inclusion: inclusionRaw } = rec

  const CONFIG: ConfigType = {
    added: () => {
      const inclusion = formatPercentage(inclusionRaw ?? 0)

      return {
        inclusion,
        label: 'Added to decks',
        tooltip: (
          <p>
            <strong>{rec.name}</strong> was added to <strong>{inclusion}%</strong> of precon decks.
          </p>
        ),
      }
    },
    cut: () => {
      const inclusion = formatPercentage(1 - (inclusionRaw ?? 0))

      return {
        inclusion,
        label: 'Cut from decks',
        tooltip: (
          <p>
            <strong>{rec.name}</strong> was cut from <strong>{inclusion}%</strong> of precon decks.
          </p>
        ),
      }
    },
  }

  const { inclusion, label, tooltip } = CONFIG[variant]()

  return (
    <StatCommonBox isInView={isInView} label={label} popover={tooltip}>
      <StatCommonFigure size='lg' suffix='%'>
        {inclusion}
      </StatCommonFigure>
    </StatCommonBox>
  )
}
